<template>
    <div id="notifications-container">
        <div
            v-for="notification in notifications"
            :key="notification.id"
        >
            <Notification :notification="notification" />
        </div>
    </div>
</template>

<style>
#notifications-container {
    display: flex;
    z-index: 5;
    position: fixed;
    bottom: 1rem;
    right: 0;
    flex-direction: column-reverse;
}
</style>

<script>
import Notification from "./Notification.vue";
import eventbus from "@eventbus";

export default {
    name: "Notifications",
    components: { Notification },
    data() {
        return {
            lastID: 1,
            notifications: [],
            type: {
                error: {
                    icon: "fa-times",
                },
                info: {
                    icon: "fa-info",
                },
                warning: {
                    icon: "fa-exclamation",
                },
            },
        };
    },
    mounted() {
        eventbus.on("notification", this.createNotification);
    },
    unmounted() {
        eventbus.off("notification", this.createNotification);
    },
    methods: {
        createNotification(notification) {
            if (!notification.disableAutoHide) {
                notification.disableAutoHide = false;
            }

            if (notification.type === "info") {
                this.$swal({
                    icon: "success",
                    showConfirmButton: false,
                    text: notification.message,
                    timer: 1250,
                    title: notification.message,
                });
                return;
            }

            this.notifications.push({
                disableAutoHide: notification.disableAutoHide,
                icon: this.type[notification.type].icon,
                id: this.lastID,
                message: notification.message,
                title: notification.title,
            });

            this.lastID += 1;
        },
        hide(notification) {
            const index = this.notifications.indexOf(notification);

            if (index > -1) {
                this.notifications.splice(index, 1);
            }
        },
    },
};
</script>
